import React, { useEffect, useState } from "react";

import styles from "./styles.css";

const ACTIVE_PAGES = ["/information/meetings/hybrid-meetings/"];

function ProductHunt(): React.ReactNode {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (ACTIVE_PAGES.includes(window.location.pathname)) {
            setIsVisible(true);
        }
    }, [setIsVisible]);

    if (!isVisible) {
        return null;
    }

    return (
        <a
            className={styles.badge}
            href={
                "https://www.producthunt.com/posts/hybrid-meetings-by-whereby?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-hybrid&#0045;meetings&#0045;by&#0045;whereby"
            }
            target={"_blank"}
            rel={"noreferrer"}
        >
            <img
                src={"https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=366422&theme=light"}
                alt={
                    "Hybrid&#0032;Meetings&#0032;by&#0032;Whereby - Hybrid&#0032;meetings&#0032;that&#0032;just&#0032;work | Product Hunt"
                }
                width={"250"}
                height={"54"}
            />
        </a>
    );
}

export default ProductHunt;
